<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h5>Настройки типов брони по направлению</h5>
      </div>
      <div class="card-body">
        <table class="table table-hover table-sm" v-if="statuses">
          <thead>
          <tr>
            <th></th>
            <th>Город</th>
            <th>Статус</th>
            <th>Тип брони</th>
            <th>Тип брони (для автосписка)</th>
          </tr>
          </thead>
          <tbody>
          <template v-for="(city, index) in cities">
            <tr :class="{'odd': index % 2 === 0}" v-for="(status, index2) in statuses">
              <td></td>
              <td>{{ city.name }}</td>
              <td>{{ status }} ({{ index2 }})</td>
              <td>
                <select class="form-control" v-model="selectedOptions[city.id][index2]">
                  <option v-for="(option, optId) in options" :value="optId">{{ option }}</option>
                </select>
              </td>
              <td>
                <select class="form-control" v-model="selectedAutoListOptions[city.id][index2]">
                  <option v-for="(option, optId) in options" :value="optId">{{ option }}</option>
                </select>
              </td>
            </tr>
          </template>
          <tr></tr>
          </tbody>
        </table>
        <div class="text-right">
          <vue-ladda @click="saveChanges" button-class="btn btn-success"
                     data-style="zoom-in"
                     :loading="loadingBtn">Сохранить
          </vue-ladda>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api';
import VueLadda from 'vue-ladda/src/vue-ladda.vue'

export default {
  components: {
    VueLadda
  },
  data() {
    return {
      loadingBtn: false,
      cities: {},
      statuses: {},
      options: {},
      selectedOptions: {},
      selectedAutoListOptions: {},
    }
  },
  mounted() {
    this.getReserveSettings();
  },
  methods: {
    async saveChanges() {
      this.loadingBtn = true;
      let {data} = await api.post('/orders/updateReserveSettings', {
        'selectedOptions': this.selectedOptions,
        'selectedAutoListOptions': this.selectedAutoListOptions
      });
      if (data.success) {
        toastr['success']('Сохранено');
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
      this.loadingBtn = false;
    },
    async getReserveSettings() {
      let {data} = await api.index('/orders/getReserveSettings');
      if (data.success) {
        this.cities = data.cities;
        this.options = data.options;

        this.cities.forEach((c) => {
          Object.keys(data.statuses).forEach((s) => {
            if (!this.selectedOptions[c.id]) this.selectedOptions[c.id] = {};
            if (!this.selectedAutoListOptions[c.id]) this.selectedAutoListOptions[c.id] = {};
            this.selectedAutoListOptions[c.id][s] = data.selectedAutoListOptions && data.selectedAutoListOptions[c.id] && data.selectedAutoListOptions[c.id][s] ? data.selectedAutoListOptions[c.id][s] : 0;
            this.selectedOptions[c.id][s] = data.selectedOptions && data.selectedOptions[c.id] && data.selectedOptions[c.id][s] ? data.selectedOptions[c.id][s] : 0;
          })
        })
        this.statuses = data.statuses;
      } else {
        toastr['warning'](data.message || 'Ошибка');
      }
    }
  }
}

</script>

<style scoped>
tr.odd {
  background-color: #f4f4f4;
}
</style>
